<template>
  <div class="approve-dialog">
    <el-dialog
      :title="title"
      :visible="visible"
      :before-close="beforeCloseHandler"
      width="800px"
    >
      <div class="wrapper">
        <div class="panel">
          <div class="panel-title">部门</div>
          <div class="panel-body">
            <el-tree
            :load="loadNode"
              lazy
              @node-click="treeNodeClick"
              :props="treeProps"
              ></el-tree>
          </div>
        </div>
        <div class="panel">
          <div class="panel-title">人员姓名</div>
          <div class="panel-body">
            <ul>
              <li v-for="item in rightList" :key="item.id+item.jobId" class="el-tree-node">
                <div class="el-tree-node__content">
                  <el-checkbox
                    class="my-checkbox"
                    :value="isItemSelected(item)"
                    @change="changeSelect(item)"
                    >{{ item.displayName || item.name }}</el-checkbox
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="closeDialog" type="info">取 消</el-button>
        <el-button type="primary" @click="submitSelectedList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeptListService, getProjectGMListService } from "@/services/sysSettingService";
import { getSubUserService, getSubService } from "@/services/departService";
import Constants from "@/utils/consts";
export default {
  name: "MeetingBillApproveDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      type: String,
      default: "选择",
    },
    approveVO: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      treeProps: {
        label: "name",
      },
      rightList: [], // 右栏候选人的列表
      selectApprove: {}, //选定的人
    };
  },
  // watch: {
  //   visible(value) {
  //     if (value&&this.remData) {
  //       this.treeNodeClick(this.remData);
  //       // this.rightList=[]
  //     }
  //   },
  // },
  methods: {
    closeDialog() {
      this.rightList=[]
      this.selectApprove={}
      this.$emit("close");
    },
    submitSelectedList() {
      this.rightList=[]
      this.$emit("close", this.selectApprove);
      this.selectApprove={}
    },

    beforeCloseHandler(done) {
      done();
      this.$emit("close");
    },

    isItemSelected(item) {
      return this.selectApprove && this.selectApprove.id == item.id;
    },
    changeSelect(item) {
      if (!this.selectApprove) {
        this.selectApprove = item;
      } else if (this.selectApprove.id == item.id) {
        this.selectApprove = undefined;
      } else {
        this.selectApprove = item;
      }
    },

    treeNodeClick(data, node) {
      // this.remData=data
      //获取该部门下对应的可以审批的候选人
      let params = {
        deptId: data.id,
        jobId: this.approveVO.jobId
      };
      getProjectGMListService(params).then(res => {
        if (res.code == Constants.Code_OK) {
          this.rightList = res.data || [];
        } else {
          this.$alert(res.msg, '提示');
        }
      }).catch(error => {
        this.$alert(error.message || error);
      })
    },

    loadNode(node, resolve) {
      // 这里就跟SelectDialog不一样
      // 这里上来第1级就可以根据用户的orgId去获取对应的部门列表，之后各级也是去获取对应的部门列表
      console.log("load node==", node.level, node);
      if (node.level == 0) {
        let reqParam = {
          pid: 0,
          orgId: sessionStorage.getItem("orgId"),
        };
        getDeptListService(reqParam)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              let list = res.data || [];
              resolve(list);
            } else if (res.code == Constants.Code_Err) {
              resolve([]);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              resolve([]);
              this.$message.error(Constants.Err_Msg);
            }
          })
          .catch((error) => {
            this.$message.error(Constants.Err_Msg);
            resolve([]);
          });
      } else {
        // 去获取各级的数据
        getSubService({ deptId: node.data.id })
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              let list = res.data || [];
              resolve(list);
            } else if (res.code == Constants.Code_Err) {
              resolve([]);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              resolve([]);
              this.$message.error(Constants.Err_Msg);
            }
          })
          .catch((error) => {
            this.$message.error(Constants.Err_Msg);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-between;
}

.panel {
  width: 50%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid #DCDFE6;
}

.panel + .panel {
  margin-left: -1px;
}

.panel-title + .panel-body {
  border-top: 1px solid #DCDFE6;
}

.panel-title {
  text-align: center;
  font-size: 18px;
  height: 50px;
  line-height: 50px;
}

.panel-body {
  display: block;
  flex: 1;
  overflow: auto;
}

.my-checkbox {
  padding-left: 6px;
}

</style>
